import RawWsService from "./RawWsService";
import LimitIncrease from "../domain/LimitIncrease";
import UserSessionService from "./UserSessionService";
import WsService from "./WsService";
import S3DocumentMetaDataWithUrl from "../domain/Registration/S3DocumentMetaDataWithUrl";

const ENDPOINT_BASE = "/registrations/limit-increase";

export default class RegistrationLimitIncreaseService {

    static requestLimitIncrease(limitIncreaseRequest) {
        let endpoint = ENDPOINT_BASE;

        let headers = UserSessionService.retrieveRegisteringHeaders();

        return RawWsService.postWithHeaders(endpoint, limitIncreaseRequest, 201, headers).then(
            response => {
                return new LimitIncrease(response.body);
            },
            response => {
                return response;
            });
    }

    static retrievePresignedUrl(s3RegistrationDocumentsUploadRequest) {

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let endpoint = ENDPOINT_BASE + "/generate-upload-url";

        return WsService.postWithHeaders(endpoint, s3RegistrationDocumentsUploadRequest, 200, registrationHeaders).then(
            response => {
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                return "Fail";
            });
    }
}
